import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

import "@fontsource-variable/raleway";
import "@fontsource-variable/open-sans";
import fonts from "./tokens/fonts";
import {
  Progress,
  IconButton,
  Radio,
  Button,
  Input,
  Skeleton,
  Drawer,
  Slider,
} from "./components";
import { colors } from "./tokens/colors";

import { screenPadding, borderRadius } from "./tokens";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: true,
};

const overrides = {
  colors,
  semanticTokens: {
    fonts,
  },
  radii: borderRadius,
  space: {
    screenPadding,
  },
  components: {
    Progress,
    Radio,
    IconButton,
    Input,
    Button,
    Skeleton,
    Drawer,
    Slider,
  },
  styles: {
    global: {
      "*": {
        WebkitTapHighlightColor: "transparent",
      },
      "html, body": {
        bg: "background",
      },
    },
  },
  config,
};

export default extendTheme(overrides);
